document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-section-id]');
  
  sections.forEach(section => {
    const banner = section.querySelector('.hero-banner-image-container');
    if (!banner) return;

    const observer = new IntersectionObserver((entries, observerInstance) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          banner.classList.add('zoom-out');
          observerInstance.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.6
    });

    observer.observe(banner);
  });
});
